import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SurveyComment } from 'src/app/interfaces/survey';

@Component({
  selector: 'app-survey-comment',
  templateUrl: './survey-comment.component.html',
  styleUrls: ['./survey-comment.component.scss'],
})
export class SurveyCommentComponent implements OnInit {

  constructor() { }

  @Input() surveyId: number | undefined;
  @Input() data: SurveyComment | undefined;
  @Input() location: 'home' | 'result' = 'home';
  @Input() isBest = false;
  @Output() onClickLike = new EventEmitter<boolean>();

  ngOnInit() {}

}
